import { ViewType } from '@/components/pages/user/class-room-play/type';
import { IClassRoomDataDetail, IParentProcess } from '@/store/types';
import AcademyMaker from '@academy/maker';
import { PayloadAction } from '@reduxjs/toolkit';
import { createSliceSteamup } from '../common';

interface IClassRoomPlayEditor {
  editor1: AcademyMaker | null;
  editor2: AcademyMaker | null;
}
export interface IClassRoomPlayState {
  processData: IParentProcess[];
  editor: IClassRoomPlayEditor;
  loading: boolean;
  purchased: boolean;
}

const createClassRoomPlaySlice = createSliceSteamup(
  'classRoomPlay',
  {
    loading: false,
    processData: [],
    editor: {
      editor1: null,
      editor2: null,
    },
    purchased: false,
  } as IClassRoomPlayState,
  {
    setMakerEditor(state, { payload }: PayloadAction<{ editor: AcademyMaker, index: 0 | 1 }>) {
      const key = payload.index === 0 ? 'editor1' : 'editor2';
      return {
        ...state,
        editor: {
          ...state.editor,
          [key]: payload.editor,
        },
      };
    },
    clearEditor(state) {
      state.editor.editor1 = null;
      state.editor.editor2 = null;
    },
  },
);

export default createClassRoomPlaySlice;
